var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.43411 7.06903C6.44551 3.50991 7.4512 1.73034 8.83127 1.27226C9.59044 1.02025 10.4083 1.02025 11.1674 1.27226C12.5475 1.73034 13.5532 3.50991 15.5646 7.06903C17.576 10.6282 18.5817 12.4077 18.28 13.8577C18.114 14.6554 17.7051 15.379 17.1119 15.9247C16.0335 16.9166 14.0222 16.9166 9.99935 16.9166C5.97656 16.9166 3.96516 16.9166 2.88682 15.9247C2.29359 15.379 1.88468 14.6554 1.7187 13.8577C1.41701 12.4077 2.42271 10.6282 4.43411 7.06903Z",
    stroke: "#D43338",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99316 12.3333H10.0007",
    stroke: "#D43338",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.99902 9.83333V6.5",
    stroke: "#D43338",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2bc1a7f470397bcab546ae3e348218d1.svg";
export { ForwardRef as ReactComponent };